<template>
  <div style="background-color: #F5F7FA;height: 100%;">
    <div style="padding: 20px;position: relative;">
        <div v-show="isShow"  class="hint">
          定位中,请等待。。。
        </div>
        <baidu-map
            class="map"
            :center="center"
            :zoom="zoom"
            @ready="handler"
            :scroll-wheel-zoom="true"
            :mapClick="false"
        >
          <bm-marker
              :position="{lng: center.lng, lat: center.lat }"
              :dragging="true"
              animation="BMAP_ANIMATION_BOUNCE">
          </bm-marker>
        </baidu-map>
      </div>
    </div>
</template>

<script>


import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "addHospital",
  data() {
    return {
      isShow:true,
      userCode: '',
      center: {
        lng: 0,
        lat: 0
      },
      zoom: ''
    };
  },
  components: {},
  methods: {
    init(userCode) {
      this.userCode = userCode;
      this. getElderly();
      this.isShow=true;
    },
    closeSelf() {
      this.$emit('closeBaiduMapReal')
    },
    handler({BMap, map}) {
      console.log(BMap, map)
      this.center.lng = 116.404;
      this.center.lat = 39.915;
      this.zoom = 15
    },
    getElderly() {

      this.$axios({
        method: 'post',
        url: this.$institutionUrl + "Positioning/PositioningForElderly",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          userCode: this.userCode
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              this.isShow=false;
              this.center.lng = response.data.data.Lon;
              this.center.lat = response.data.data.Lat;
            } else if (response.data.error === 1) {
              this.isShow=false;
              this.$message.error(response.data.message)
            } else {
              this.isShow=false;
              this.$message({type: 'info', message: '定位失败'});
            }
          }
      )
    }
  }
};

</script>

<style>

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}


</style>


<style lang="scss" scoped>
.map {
  width: 100%;
  height: 510px;
}
.hint{
  position: absolute;
  z-index: 1000;
  color: red;
  font-size: 20px;
  margin: 10px;
}



</style>
